export default {
    placeholder: 'Комментарий не добавлен',
};
